import React, { Component } from "react";
import { Link } from "react-router-dom";
import client from "@culturehq/client";
import { Loader, Panel, Subnav } from "@culturehq/components";

import { errorService, t } from "app/utils";

import ErrorBoundary from "components/common/ErrorBoundary";
import AvailableSurveys from "./surveys/AvailableSurveys";
import CompletedSurveys from "./surveys/CompletedSurveys";

const SurveysView = ({ availableActive, availableSurveys, completedSurveys, onSurveyComplete }) => {
  if (!availableActive) {
    return <CompletedSurveys surveys={completedSurveys} />;
  }

  return (
    <AvailableSurveys
      surveys={availableSurveys && availableSurveys.slice(0, 3)}
      onSurveyComplete={onSurveyComplete}
    />
  );
};

class Surveys extends Component {
  state = {
    availableActive: true,
    availableSurveys: null,
    completedSurveys: null,
    completedSurveysFetched: false,
    loading: true
  };

  componentDidMount = async () => {
    this.componentIsMounted = true;

    try {
      const { surveys } = await client.listProfileAvailableWidgetSurveys();
      this.mountedSetState({ availableSurveys: surveys, loading: false });
    } catch (error) {
      errorService.error(error);
      this.mountedSetState({ availableSurveys: [], loading: false });
    }
  };

  componentWillUnmount() {
    this.componentIsMounted = false;
  }

  loadCompletedSurveys = async () => {
    this.setState({ loading: true });

    try {
      const { surveys } = await client.listProfileCompletedWidgetSurveys({
        viewableResults: true
      });

      this.mountedSetState({
        completedSurveys: surveys,
        completedSurveysFetched: true,
        loading: false
      });
    } catch (error) {
      errorService.error(error);
      this.mountedSetState({
        completedSurveys: [],
        completedSurveysFetched: true,
        loading: false
      });
    }
  };

  handleChange = index => {
    if (index === 0) {
      this.handleAvailableClicked();
    } else {
      this.handleCompletedClicked();
    }
  };

  handleAvailableClicked = () => {
    this.setState({ availableActive: true });
  };

  handleCompletedClicked = () => {
    const { completedSurveysFetched, loading } = this.state;
    if (!completedSurveysFetched && !loading) {
      this.loadCompletedSurveys();
    }

    this.setState({ availableActive: false });
  };

  handleSurveyComplete = survey => {
    this.setState(({ availableSurveys, completedSurveys, completedSurveysFetched }) => ({
      availableSurveys: availableSurveys.filter(({ id }) => id !== survey.id),
      completedSurveys: completedSurveysFetched ? [survey, ...completedSurveys].slice(0, 3) : null
    }));
  };

  mountedSetState = newState => {
    if (this.componentIsMounted) {
      this.setState(newState);
    }
  };

  render() {
    const { availableActive, availableSurveys, completedSurveys, loading } = this.state;

    return (
      <Panel className="SidePanel widget-surveys">
        <Panel.Heading>Surveys</Panel.Heading>
        <Panel.Body>
          <Subnav ariaLabel={t("Surveys categories")} onChange={this.handleChange}>
            <Subnav.Item>Available</Subnav.Item>
            <Subnav.Item>Completed</Subnav.Item>
          </Subnav>
          <Loader loading={loading}>
            <ErrorBoundary>
              <SurveysView
                availableActive={availableActive}
                availableSurveys={availableSurveys}
                completedSurveys={completedSurveys}
                onSurveyComplete={this.handleSurveyComplete}
              />
            </ErrorBoundary>
          </Loader>
        </Panel.Body>
        <Panel.Footer>
          <Link to="/surveys">View all</Link>
        </Panel.Footer>
      </Panel>
    );
  }
}

export default Surveys;
